export const SCROLL_END_HANDLER_PADDING = 100;

export const CONTENT_WIDTH = 1232;

export const DEFAULT_FONT_NAME = "Mulish";

export const DASHBOARD_MODE = {
  COMPANY: "company",
  SHARED: "shared",
}